export const REACT_APP_RAPID_API_URL="https://judge0-ce.p.rapidapi.com/submissions";
export const REACT_APP_RAPID_API_HOST="judge0-ce.p.rapidapi.com";
export const REACT_APP_RAPID_API_KEY="a05dc01bc4msh4ce44a752e32965p1ff6dfjsn1ddc20b5e1bd";
